// extracted by mini-css-extract-plugin
export default {"icon":"FilterTable_icon__XSnJX"};